import React from "react";
import "./CardPaginator.scss"
import { ButtonBase } from "@material-ui/core";
import '../../../node_modules/font-awesome/css/font-awesome.min.css'

export interface CardPaginatorProps {
    infoText?: any;
    iconName?: any;
    onExpand?(): void;

}

export interface CardPaginatorState {

}

class CardPaginator extends React.Component<CardPaginatorProps, CardPaginatorState> {
    constructor(props: CardPaginatorProps) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="paginator-info">
                <div>
                    <p>{this.props.infoText}</p>
                </div>
                <ButtonBase style={{
                    padding: 5,
                    width: "10%",
                    outline: "none"
                }}
                    disableRipple={false}
                    centerRipple={true}

                >
                    <div className="icon-left" onClick={() => this.props.onExpand && this.props.onExpand()}>
                        <i className={this.props.iconName} />
                    </div></ButtonBase>
            </div>
        );
    }
}

export default CardPaginator;